import React from 'react';

const Impressum = () => {
  return (
    <div className="container legal-page">

      {/* ================= Schulung – Datenschutz ================= */}
      <section className="legal-section">
        <h1>Schulung – Überblick zum Datenschutz</h1>

        <h2>1. Einleitung</h2>
        <p>
          Nachfolgend wollen wir Ihnen einen generellen Überblick zu allen
          datenschutzrelevanten Themen geben. Dadurch erlangen Sie das notwendige
          Basiswissen, um in Zukunft datenschutzkonform arbeiten zu können.
        </p>
        <p>
          Denn nur so können Sie sich und Ihr Unternehmen vor Abmahnungen,
          Strafzahlungen und anderen Konsequenzen aktiv schützen.
        </p>

        <h2>2. Datenschutz-Management-System</h2>
        <p>
          DATENSCHUTZ-MANAGEMENT bedeutet, die gesetzlichen und
          betrieblichen Anforderungen des Datenschutzes systematisch zu planen, zu
          organisieren, zu steuern und zu kontrollieren. Damit dies möglich wird und
          nachweisbar ist, braucht man ein entsprechendes SYSTEM. Bereits
          getroffenen und geplante datenschutzrechtliche Maßnahmen werden also
          überprüfbar dokumentiert und können bei Bedarf leicht angepasst werden
        </p>

        <h2>3. Datenschutzverletzung</h2>
        <p>
          Eine Datenschutzverletzung nach der DSGVO bedeutet ganz vereinfacht,
          dass der Schutz von (personenbezogenen) Daten nicht ausreichend
          funktioniert hat.
          Wichtig ist es, dann angemessen und zeitnah zu reagieren. Als Mitarbeiter
          muss man also immer einfach, die zuständige (vorgesetzte) Stelle
          informieren, damit die Geschäftsleitung entscheiden kann, was zu tun ist.
          Neben der notwendigen Dokumentation (potentieller) Verletzungen kann das
          auch die Meldung an die Aufsichtsbehörde und eine Betroffenenmitteilung
          sein.

        </p>

        <h2>4. Auftragsverarbeitungsvertrag (AVV)</h2>
        <p>
          Werden personenbezogenen Daten von einem anderen Unternehmen "nach
          einem Auftrag verarbeitet" (z.B. Speichern von Daten bei einem CloudAnbieter), so darf der Schutz dieser Daten dann nicht geringer ausfallen als
          vor der Weitergabe an das andere Unternehmen. Um das zu gewährleisten,
          2
          schließt der Auftraggeber mit dem Auftragnehmer einen sogenannten AVV. In
          diesem sendet der Auftragnehmer regelmäßig seine technischen und
          organisatorischen Maßnahmen (TOMs) zum Schutz von Daten mit.
        </p>

        <h2>5. Technische und organisatorische Maßnahmen (TOMs)</h2>
        <p>
          Technische und organisatorische Maßnahmen (TOMs) sind die nach Art. 32
          DSGVO vorgeschriebenen Maßnahmen, um die Sicherheit der Verarbeitung
          personenbezogener Daten zu gewährleisten.

        </p>
        <p>Das bedeutet, man listet alle Maßnahmen auf, die technisch (z.B.
          Sicherheitsschloss) und organisatorisch (z.B. Anweisung "Abzuschließen") im
          Unternehmen eingesetzt werden, um den Schutz von Daten zu gewährleisten.
        </p>
        <p>Damit dokumentiert man bereits getroffenen Maßnahmen und kann
          feststellen, ob bzw. welche weiteren Maßnahmen zu ergreifen sind.</p>

        <h2>6. Berechtigungskonzept</h2>
        <p>
          Ein essenzieller Teil der organisatorischen Maßnahmen ist ein sogenanntes
          Berechtigungskonzept.
        </p>
        <p>In diesem wird festgelegt und dokumentiert, wer auf welche Daten wie
          zugreifen kann. Es wird so gestaltet, dass Daten vor unrechtmäßigen
          Veränderungen/Einsichtnahmen geschützt sind, ohne die Produktivität des
          Unternehmens zu beeinträchtigen.</p>
        <p>Auch hier dokumentiert und kontrolliert man also, dass alle Personen auf die
          Daten zugreifen können, die sie zur problemlosen Erledigung ihrer Arbeit
          benötigen.
        </p>

        <h2>7. Datenschutzerklärung und andere Informationspflichten</h2>
        <p>Unternehmen sind nach Art. 13 und 14 DSGVO verpflichtet die Betroffenen
          (Website-Besucher/Kunden/Partner) über die Verarbeitung von
          personenbezogenen Daten durch das Unternehmen zu informieren.</p>
        <p>Dafür findet man in Art. 13 und 14 DSGVO detaillierte Regelungen, wann über
          was informiert werden muss. Zwei wichtige Punkte sind u.a. den Zweck (z.B.
          Speicherung für Rechnungen) und die Rechtsgrundlage (diese finden sich in
          Art. 6 DSGVO) der Verarbeitung zu nennen.</p>
        <p>Einen Teil dieser Informationen stellt die Datenschutzerklärung auf der
          Website dar. An dieser Stelle informiert man über die Verarbeitung von
          personenbezogenen Daten, die mit dem Besuch deiner Website einhergeht
          (z.B. über die Weiterleitung der IP-Adresse an den Provider zum Zwecke der
          Darstellung der Website aufgrund von Art. 6 Abs. 1 S. 1 lit. a DSGVO). In
          diesem Zusammenhang muss man auch "Cookies" betrachten, die je nach
          eingesetzten Programmen und Einstellungen gesetzt werden.
        </p>
        <p>Eine weitere Informationspflicht findet sich im Impressum. Auch wenn sich die
          Impressumspflicht nicht aus "dem Datenschutz" ergibt, hängt dies doch sehr
          eng mit der rechtmäßigen Erstellung einer Website zusammen.
        </p>

        <h2>8. Allgemeine Informationspflichten
        </h2>

        <p>Allerdings verarbeitet man regelmäßig auch Daten, die nicht über die Website
          erhoben werden (z.B. in der Kontaktaufnahme/Kommunikation mit deinen
          Kunden/Geschäftspartnern usw.). Auch hier muss man mitteilen, welche
          Daten zu welchen Zwecken aufgrund welcher Rechtsgrundlage wann und wie
          lange erhoben/gespeichert/weitergeleitet/usw. werden.
        </p>
        <p>Ein weiterer wichtiger Punkt ergibt sich aus der Nutzung von externen
          Diensten, um dein Unternehmen zu präsentieren oder dein Produkt zu
          verkaufen (Social Media/Shops). Dann kann eine sogenannte gemeinsame
          Verantwortung nach Art. 26 DSGVO vorliegen. Auch darüber muss
          entsprechend informiert werden.</p>

        <h2>9. Einschub: Rechtsgrundlagen</h2>
        <p>Mehrfach ist der Begriff "Rechtsgrundlage" gefallen. Dies ist ein zentrales
          Element im Datenschutz. Vereinfacht gesagt, darf man personenbezogene
          Daten nie verarbeiten, also irgendwas damit machen, solange es keine
          Rechtsgrundlage für die Verarbeitung gibt</p>
        <p>Diese finden sich in Art. 6 DSGVO und regeln, warum man eben doch
          bestimmte Daten verarbeiten darf. Exemplarisch folgt ein Beispiel, denn es
          handelt sich um ein ziemlich bekanntes Prinzip:</p>
        <p>Möchte oder kann ein Arbeitnehmer nicht zur Arbeit, brauchst er dafür einen
          Grund (meist Urlaub oder Krankheit).</p>
        <p>Benötigt er Urlaub, muss er seinen Arbeitgeber (normalerweise) fragen. Er
          braucht also die entsprechende Einwilligung.</p>
        <p>Ist er hingegen krank, reicht es (in der Regel), wenn er darüber (über diesen
          Grund) informiert (ggfs. mit Attest). Es überwiegt also sein (berechtigtes)
          Interesse an Gesundung, das Interesse des Arbeitgebers an Arbeitsleistung</p>
        <p>So ist es auch beim Datenschutz. Möchte man Daten verarbeiten, kann es
          sein, dass man ein berechtigtes Interesse daran hat oder vorher in die
          Verarbeitung eingewilligt wurde. Die Gründe für eine Verarbeitung, und damit
          die Rechtsgrundlage, sind also ein berechtigtes Interesse an der Verarbeitung
          oder eine Einwilligung durch den Rechteinhaber (denn jeder Mensch hält die
          Rechte an seinen personenbezogenen Daten). Weitere
          Gründe/Rechtsgrundlagen finden sich in Art. 6 DSGVO.</p>
        <h2>10. Videoüberwachung</h2>
        <p>Jegliche Videoüberwachung erfordert einen besonderen
          datenschutzrechtlichen Umgang. Das liegt daran, dass bei einer
          Videoaufnahme regelmäßig sensiblere (personenbezogene) Daten verarbeitet
          werden als z.B. bei dem Besuch einer Website. Allein die Aufzeichnung stellt
          schon einen starken Eingriff in die Privatsphäre dar. Deswegen sind die
          Anforderungen an eine rechtmäßige Videoüberwachung auch deutlich höher
          als z.B. bei der Verarbeitung einer IP-Adresse. Zudem muss mit einem gut
          sichtbaren Aushang auf die Überwachung hingewiesen werden.
        </p>
        <h2>11. Betroffenenrechte</h2>
        <p>Das Kapitel 3 der DSGVO heißt "Rechte der betroffenen Personen". Betroffen
          ist jede Person, von der Daten i.S.d. DSGVO verarbeitet werden. Diese
          Personen erhalten ganz konkrete Betroffenenrechte. Zudem ergibt sich aus
          diesem Kapitel der DSGVO eine Reihe von (Informations-)Pflichten für
          Unternehmen.</p>
        <p>Zu den konkreten Rechten gehören ein:</p>
        <ul>
          <li>Auskunftsrecht</li>
          <li>Recht auf Berichtigung</li>
          <li>Recht auf Löschung</li>
          <li>Recht auf Einschränkung der Verarbeitung</li>
          <li>Recht auf Datenübertragbarkeit</li>
          <li>Recht auf Widerspruch</li>
          <li>Recht auf Widerruf</li>
          <li>Recht auf Entscheidung im Einzelfall</li>
          <li>Beschwerderecht bei der Aufsichtsbehörde</li>
        </ul>
        <p>Nicht alle Rechte habe die gleiche praktische Relevanz für Unternehmen.
          Allerdings ist es wichtig zeitnah und angemessen zu reagieren bzw. regieren
          zu können. Dadurch kann ein nachträglicher hoher Arbeitsaufwand und
          Bußgelder vermieden werden.
        </p>

        <h2>12. Mitarbeiter - Beschäftigtendatenschutz
        </h2>
        <p>Der Schutz der Daten von Mitarbeitern spielt eine wichtige Rolle.
        </p>
        <p>Bereits im Bewerbungsprozess muss man darauf achten, welche
          Informationen überhaupt abgefragt, wem diese Infos zugänglich gemacht und
          wann diese Daten wieder gelöscht werden.
        </p>
        <p>Für die Verarbeitung von Daten aktueller Mitarbeiter gilt der Grundsatz, dass
          man nur solche Daten verarbeiten darf, die für das Beschäftigungsverhältnis
          notwendig sind. Möchte man darüber hinaus Mitarbeiterdaten verwenden,
          benötigt man oft eine entsprechende Einwilligung.
        </p>
        <p>Scheidet ein Mitarbeiter aus dem Unternehmen aus, gibt es gewisse Daten,
          die gelöscht werden müssen. Andere Daten hingegen unterliegen
          Aufbewahrungspflichten und müssen für einen gewissen Zeitraum aufbewahrt
          werden.</p>

        <h2>13. Mitarbeiter - Schulung und Homeoffice</h2>

        <p>Neben dem Schutz von Mitarbeiterdaten müssen auch die Mitarbeiter wissen,
          wie man mit personenbezogenen Daten "richtig" umgeht.</p>
        <p>Deswegen sieht die DSGVO regelmäßige Schulungen vor. Jeder Mitarbeiter
          soll hier einen guten Überblick zum Datenschutzrecht gewinnen und
          grundsätzlich wissen, was bei der Verarbeitung von personenbezogenen
          Daten zu beachten ist. Darüber hinaus gilt es dieses Wissen zu erhalten und
          ggfs. zu vertiefen.
        </p>
        <p>Ein Teil dieser Vertiefung stellt das Arbeiten im Home- oder Mobileoffice dar.
          Hier sind Daten grundsätzlich einem höheren Risiko ausgesetzt und ein
          geschulter Umgang ist folglich besonders wichtig.
        </p>

        <h2>14. Verarbeitungsverzeichnis (VVT)</h2>
        <p>In einem Verarbeitungsverzeichnis sind gemäß Art. 30 DSGVO alle
          Datenverarbeitungsvorgänge von personenbezogenen Daten(kategorien) zu
          erfassen und zu beschreiben</p>
        <p>Das bedeutet, man musst detailliert aufschreiben, wie, wann, durch wen,
          welche Daten verarbeitetet werden und wie diese Daten geschützt werden, an
          wen sie ggfs. weitergeleitet werden, wann eine Löschung stattfindet, usw.</p>
        <p>Ein solches Verzeichnis bietet einen guten grundsätzlichen Überblick über
          Datenverarbeitungsvorgänge in einem Unternehmen und kann jederzeit von
          der zuständigen Aufsichtsbehörde angefordert werden. Fehlt es oder ist es
          unvollständig, drohen hohe Bußgelder.</p>

        <h2>15. Löschkonzept</h2>
        <p>In einem Löschkonzept muss festgehalten werden, wann, welche Daten,
          durch wen und wie, regelmäßig gelöscht werden. Es werden also Regeln
          formuliert, nach welchen gewisse Daten(kategorien) regelmäßig gelöscht
          werden müssen.</p>
        <p>Dieser Löschverpflichtung steht allerdings immer auch eine
          Aufbewahrungspflicht entgegen.</p>
        <p>Um diese Gratwanderung zwischen Lösch- und Aufbewahrungspflichten
          effektiv und erfolgreich zu absolvieren, muss ein Löschkonzept erstellt
          werden. Andernfalls löscht man Daten, die noch "gebraucht werden" oder es
          werden Daten aufbewahrt, die eigentlich längst gelöscht werden müssten.</p>
        <h2>16. Datenschutz-Folgenabschätzung (DSFA)</h2>
        <p>Eine Datenschutz-Folgenabschätzung ist als Risikoabschätzung immer dann
          erforderlich, wenn die Verarbeitung von Daten voraussichtlich ein hohes
          Risiko für die Rechte und Freiheiten natürlicher Personen zur Folge hat.</p>
        <p>Man muss also bewerten, welches Risiko für die Betroffenen bzw. für ihre
          Daten durch eine ausgeführte Verarbeitung entsteht. Um besser eingrenzen
          zu können, wann eine DSFA notwendig ist, stellen einige Aufsichtsbehörden
          sogenannte "Muss-Listen" zur Verfügung.</p>
        <h2>17. Abschluss</h2>
        <p>Durch das aufmerksame Lesen dieses Dokuments haben Sie bereits einen
          guten ersten Überblick zu allen datenschutzrechlich relevanten Themen
          erhalten. Das ist die Basis für ein DSGVO-konformes, und damit sicheres
          Arbeiten, mit personenbezogenen Daten.
        </p>
        <p>Weiterführende Informationen und Handlungsempfehlungen erhalten Sie
          immer passend zu den Themengebieten, die in dem Unternehmen konkret
          bearbeitet werden. Ein gutes Basiswissen wird Ihnen die Umsetzung enorm
          erleichtern.</p>
        <p>Danke für Ihre Zeit und die Bereitschaft sich an der Erfüllung der gesetzlichen
          Vorschriften aktiv zu beteiligen. Damit schützen Sie Ihr Unternehmen und
          auch sich persönlich vor möglichen negativen Konsequenzen.</p>
      </section>

      <hr className="divider" />

      {/* ================= Impressum ================= */}
      <section className="legal-section">
        <h1>Impressum</h1>

        <h2>Anbieter</h2>
        <p>
          <strong>GETAM CINE WORLD EUROPE</strong><br />
          Rudower Str. 132<br />
          12351 Berlin<br />
          Deutschland
        </p>

        <h2>Vertreten durch</h2>
        <p>Balamurali Murugaiah</p>

        <h2>Kontakt</h2>
        <p>
          E-Mail: <a href="mailto:info@getam.eu">info@getam.eu</a><br />
          Telefon: <a href="tel:+4915123727232">+49 1512 3727232</a>
        </p>

        <h2>Umsatzsteuer-ID</h2>
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
          <strong>DE1234567891231</strong>
        </p>

        <h2>Haftungsausschluss</h2>
        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte
          auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
        </p>

        <h2>Haftung für Links</h2>
        <p>
          Für Inhalte externer Links übernehmen wir keine Haftung, da wir auf
          deren Inhalte keinen Einfluss haben.
        </p>

        <h2>Social-Media-Profile</h2>
        <ul>
          <li>
            Instagram:{' '}
            <a href="https://www.instagram.com/getamcineworld/" target="_blank" rel="noopener noreferrer">
              https://www.instagram.com/getamcineworld/
            </a>
          </li>
          <li>
            Facebook:{' '}
            <a href="https://www.facebook.com/getamcinema/" target="_blank" rel="noopener noreferrer">
              https://www.facebook.com/getamcinema/
            </a>
          </li>
          <li>
            TikTok:{' '}
            <a href="https://www.tiktok.com/@cineworld" target="_blank" rel="noopener noreferrer">
              https://www.tiktok.com/@cineworld
            </a>
          </li>
        </ul>

        <p className="footer-note">
          Erstellt mit freundlicher Unterstützung von Dieter macht den Datenschutz
        </p>
      </section>

    </div>
  );
};

export default Impressum;
